import { unifiedAgentEvent } from './unifiedAgentEvent'

export type IConfigureSectionModifiedCounts = {
  trigger: number
  instructions: number
  knowledgeBase: number
  booking: number
  autoFollowUp: number
}

export type IConfigureSection = keyof IConfigureSectionModifiedCounts

export const unifiedAgentSectionModifiedLogEvent = unifiedAgentEvent<{
  build_session_id: string | null
  sections: IConfigureSectionModifiedCounts
  agent_id?: number | null
}>('Unified_Agent_Section_Modified')
